export default "__VITE_ASSET__DjF5QP3Z__"